export default __webpack_public_path__ + "static/media/reward-4.2799b8cd.png";